'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

type ScrollToTopProps = {
  scrollRef: React.RefObject<HTMLDivElement | null>;
};


export const ScrollToTopOnRouteChange = ({ scrollRef }: ScrollToTopProps) => {
  const pathname = usePathname();

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};
